// extracted by mini-css-extract-plugin
export default {"table_container":"style_table_container__WaJ6M","data_table":"style_data_table__0JSOV"};